import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

type SidebarItemProps = {
   data: any
   selectedKeys: any
}

const SidebarItem: React.FC<SidebarItemProps> = observer(({ data, selectedKeys }) => {
   // const JobsStore = useStore('JobsStore')
   // const jobsCount: any = JobsStore.jobsCount

   const { t } = useTranslation()
   const [jobCount, setJobCount] = useState<number>(0)
   // useEffect(() => {
   //    // const count = jobsCount[data?.type] || 0
   //    // setJobCount(count)
   //    // (jobsCount)
   // }, [Object.values(jobsCount).map((item: any) => item)])
   // console.log(
   //    'selectedKeys',
   //    selectedKeys,
   //    'data?.path',
   //    data?.path,
   //    `selectedKeys.startsWith(data?.path + '')`,
   //    selectedKeys.startsWith(data?.path + '')
   // )

   return (
      <Badge count={jobCount} offset={[24, 7]} overflowCount={99} className={`${jobCount > 99 ? 'overflow' : ''}`}>
         <div
            style={{
               justifyContent: 'flex-start',
               display: 'flex',
               alignItems: 'center',
               marginTop: 10,
               overflow: 'hidden',
               minWidth: 200
            }}
         >
            <img src={data?.icon} alt="" style={{ width: 20, height: 20, marginRight: 10 }} />
            <span
               className="nav-item__label"
               style={
                  // (data?.path + '')?.includes(selectedKeys)
                  selectedKeys.includes(data?.path)
                     ? // selectedKeys.startsWith(data?.path + '')
                       { color: '#ED5C19', fontWeight: '500', fontSize: 13 }
                     : { fontSize: 13 }
               }
            >
               {t(data?.labelKey)}
            </span>
         </div>
      </Badge>
   )
})

export default SidebarItem
